import moment from 'moment'

export default {
  name: 'appointmentCalendar',
  data: function () {
    return {
      locale: 'fr',
      selectedDate: null,
      disabledDates: []
    }
  },

  props: {
    availableDates: Array
  },
  methods: {

    /**
   * @function
   * @name setLocale
   * @descrription Sets the language
   */
    setLocale () {
      this.locale = localStorage.getItem('locale')
    },

    handleOnInput() {
      this.$emit(
        'clickDate',
        moment(Object(this.selectedDate)).format('DD/MM/YYYY')
      )
    }
  },
  /**
   * @function
   * @name mounted
   * @descrription Executes the setMinDate and setLocale methods
   */
  mounted () {
    this.setLocale()
    if (this.availableDates.length === 0) {
      this.disabledDates = { weekdays: [1, 2, 3, 4, 5, 6, 7] }
    }
  }
}
